import { render, staticRenderFns } from "./BaseCountCard.vue?vue&type=template&id=058f46d5&scoped=true"
import script from "./BaseCountCard.vue?vue&type=script&lang=js"
export * from "./BaseCountCard.vue?vue&type=script&lang=js"
import style0 from "./BaseCountCard.vue?vue&type=style&index=0&id=058f46d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f46d5",
  null
  
)

export default component.exports